module.exports = __webpack_public_path__ + "img/vertical_7_5_4.bb859a68.png";